/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sources_TitleInputs */

const es_settings_sources_title = /** @type {(inputs: Settings_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes de información dinámica`)
};

const en_settings_sources_title = /** @type {(inputs: Settings_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic data sources`)
};

/**
* | output |
* | --- |
* | "Dynamic data sources" |
*
* @param {Settings_Sources_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_sources_title = /** @type {((inputs?: Settings_Sources_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sources_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_sources_title(inputs)
	return en_settings_sources_title(inputs)
});
export { settings_sources_title as "settings.sources.title" }